import React from 'react';

export const AboutSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              專業人力資源，助您無憂招聘
            </h2>
            <div className="space-y-6 text-gray-600">
              <p className="text-lg">
                萬業人才資本持有香港職業介紹所牌照，在香港、深圳、廣州及福建設有招聘辦公室，擁有超過十年豐富經驗，專為香港僱主提供一站式外勞招聘服務。
              </p>
              <p>
                我們的目標是讓僱主輕鬆招聘到合適外勞，同時確保外勞順利適應香港工作與生活。
              </p>
              <p>
                我們的團隊立足香港超過10年，專注於各類型公司業務的收購合併，過往我們成功售出的公司超過1,000間，買家當中包括上市公司、中小企及獨立投資者等，所以我們對各行各業都有深厚的認識，更容易協助各個企業的負責人處理外勞申請。
              </p>
            </div>
            
            <div className="mt-8 grid grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-green-600 mb-2">10+</div>
                <div className="text-sm text-gray-600">年經驗</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-green-600 mb-2">100+</div>
                <div className="text-sm text-gray-600">成功案例</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-green-600 mb-2">14</div>
                <div className="text-sm text-gray-600">合作勞務公司</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/2bb539c44d9219f33708ed9c947650a4.jpg"
              alt="位於灣仔的香港職業介紹所專業辦公環境"
              className="rounded-xl shadow-lg object-cover w-full h-96"
            />
            <div className="absolute -bottom-6 -left-6 bg-green-600 text-white p-6 rounded-lg shadow-xl">
              <div className="text-2xl font-bold">香港職業介紹所</div>
              <div className="text-sm">(牌照號碼: 80063) 持牌經營</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
